import React from 'react';
import './styles/main.css'
import Home from './components/pages/Home';

class Centralizer extends React.Component {

  render() {
    return (
      <Home />
    )
  }
}

export default Centralizer;
